module.exports = __webpack_public_path__ + "static/img/IMG_20170729_203502.a3871ea2.jpg";